<template>
    <v-container>
        <v-row>
            <v-col
                    cols="12"
            >
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'en' ">Blog</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'es' ">Blog</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'pt' ">Blog</h1>
                <hr>
                <v-row>
                    <v-col cols="12" md="3" sm="6" v-for="(blog,index) in news"
                           :key="'house'+index">
                        <v-card :to="blog.meta_url">
                            <template slot="progress">
                                <v-progress-linear
                                        color="orange"
                                        height="5"
                                        indeterminate
                                ></v-progress-linear>
                            </template>
                            <v-img
                                    height="500"
                                    :src="cdnUrl+blog.images"
                            ></v-img>
                            <v-card-title v-if="lang == 'en'">{{ blog.title_en}}</v-card-title>
                            <v-card-title v-if="lang == 'pt'">{{ blog.title_pt}}</v-card-title>
                            <v-card-title v-if="lang == 'es'">{{ blog.title_e}}</v-card-title>

                            <v-card-text>
                                <div v-if="lang == 'en'">{{ blog.short_description_en}}</div>
                                <div v-if="lang == 'pt'">{{ blog.short_description_pt}}</div>
                                <div v-if="lang == 'ws'">{{ blog.short_description_es}}</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        color="orange"
                                        text
                                >
                                    <span v-if="lang=='en'">More</span>
                                    <span v-if="lang=='pt'">Veja mais</span>
                                    <span v-if="lang=='es'">Mais</span>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            lang: { type: String },
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        metaInfo () {
            return {
                title: 'Best Choice Vacation - Blog',
                meta: [
                    {description: 'Best Choice Vacation - Blog'},
                    {keywords: 'Best Choice Vacation - Blog'}
                ]
            }
        },
        data () {
            return {
                news:{

                }
            }
        },
        methods:{

        },
        mounted(){
            this.$http.get(this.appUrl+"/store/blog").then(response =>{
                this.news = response.data;
            });
        },
        filters:{

        }
    }
</script>
